<div class="imei-lookup-outer-container">
  <div class="device-caption" *ngIf="!isOnboardingFlow">
    <adp-label [context]="preHeaderTextContext" labelKey="RegisterCellularDevice_PreSelectedDevice_DisplayName_Text"></adp-label>
  </div>
      <div class="info-container">
        <div class="headings-container">
          <div class="heading">
            <adp-label *ngIf="isTablet" labelKey="RegisterTablet_Serial_Heading"></adp-label>
            <adp-label *ngIf="isSmartwatch" labelKey="RegisterSmartwatch_Serial_Heading"></adp-label>
            <adp-label *ngIf="isSmartphone" labelKey="RegisterNumber_IMEI_Heading"></adp-label>
          </div>
          <div class="subheading" *ngIf="isSmartphone && !isOnboardingFlow">
            <adp-label labelKey="RegisterNumber_Subheading"></adp-label>
          </div>
        </div>
        <div modal-body class="input-container">
          <form [formGroup]="serialNumberForm" name="serialNumberFormGroup" class="enter-phonenumber-form">
            <div class="row">
                <div>
                  <adp-input class="field-input w-100"
                      [resourceData]="resourceService.getResourceObject('Onboarding_Diagnostic_ExtraInfo_Serial_Field')"
                      formControlName="serialNumber"></adp-input>
                </div>
                <div class="field-input w-100">
                <div class="serial-info-container">
                    <div style="color:#3D515A;">
                      <div>
                        <mat-icon style="height:26px;width:26px;overflow:visible !important;"><ng-container *ngTemplateOutlet="infoIcon"></ng-container></mat-icon>
                        <span style="font-weight:600;margin-left:5px;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Header"></adp-label></span>
                      </div>
                      <ul *ngIf="isTablet" style="margin-top:10px;">
                        <li style="font-weight:500;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Bullet1"></adp-label>
                          <ol>
                            <li style="font-weight:400;margin-top:5px;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Bullet1a"></adp-label></li>
                            <li style="font-weight:400;margin-top:5px;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Bullet1b"></adp-label></li>
                          </ol>
                        </li>
                        <li style="font-weight:500;margin-top:10px;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Bullet2"></adp-label></li>
                        <li style="font-weight:500;margin-top:10px;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Bullet3"></adp-label></li>
                      </ul>
                      <ul *ngIf="isSmartwatch" style="margin-top:10px;">
                        <li style="font-weight:500;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Smartwatch_Bullet1"></adp-label></li>
                        <li style="font-weight:500;margin-top:10px;"><adp-label labelKey="RegisterCellularDevice_Serial_Info_Smartwatch_Bullet2"></adp-label></li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
              <div><button class="register-phone-button" mat-flat-button color="accent"
                  (click)="submitForm()" [disabled]="!serialNumberForm.valid"><adp-label
                    labelKey="Global_Button_Next"></adp-label></button>
              </div>
            </div>
          </form>
        </div>
      </div>
  <ng-template #infoIcon>

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2585_54571)">
      <path d="M13 15.5C12.1727 15.5 11.5 14.8273 11.5 14V11.5H11C10.724 11.5 10.5 11.276 10.5 11C10.5 10.724 10.724 10.5 11 10.5H11.5C12.0513 10.5 12.5 10.9487 12.5 11.5V14C12.5 14.276 12.724 14.5 13 14.5H13.5C13.776 14.5 14 14.724 14 15C14 15.276 13.776 15.5 13.5 15.5H13Z" fill="currentColor"/>
      <path d="M11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5Z" fill="currentColor"/>
      <path d="M12 20C7.58867 20 4 16.4113 4 12C4 7.58867 7.58867 4 12 4C16.4113 4 20 7.58867 20 12C20 16.4113 16.4113 20 12 20ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z" fill="currentColor"/>
      </g>
      <defs>
      <clipPath id="clip0_2585_54571">
      <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
      </clipPath>
      </defs>
      </svg>

      </ng-template>

</div>
